import { useContext, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { ProductContext } from "../../../context/ProductContext";
import { useNavigation } from "../../../utils/navigation";
import { AuthUserContext } from "../../../context/AuthUserContext";
import { useTranslation } from "react-i18next";
const fadeInTop = keyframes`
  from {
    clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  }
  to {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    
  }
`;
const fadeOutBottom = keyframes`
  from {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
  to {
    clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  }
`;
const Container = styled.div`
  width: 100%;
  background-color: var(--bg-200);
  overflow-y: auto; /* Omogućava vertikalno skrolovanje */
  height: calc(100vh - 100px);

  display: flex; /* Dodato za flexbox layout */
  flex-direction: column;
`;
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  min-height: 100%;
  @media (min-width: 768px) {
    //max-width: var(--max-width-container);
  }
`;
const GridContainer = styled.div`
  min-width: 100%;
  height: 100%;
  min-height: 100%;

  overflow-x: hidden;
  position: relative;
`;
const GridItems = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
`;

const ButtonWrapper = styled.div`
  box-shadow: var(--shadow-small);
  border-bottom: 1px solid var(--bg-200);
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Button = styled.button`
  text-transform: uppercase;
  font-weight: 600;
  background-color: var(--bg-200);
  color: var(--text-200);
  border: none;
  border-radius: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 94%;
  font-size: var(--font-size-large);
  font-weight: 200;
  padding: 12px 0;

  &:hover {
    background-color: var(--bg-200);
  }
  // min-width: 100%;
`;
const ButtonIcon = styled.span``;
const CategoryGrid = styled.div`
  align-self: center;
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 4px;
  width: 94%;
`;
const CategoryGridItem = styled.div`
  border-radius: 20px;
  background-color: var(--accent-200);
  color: var(--bg-200);
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;
`;

const DropDown = styled.div`
  /* Samo za telefone, primenjuje se display na osnovu $isOpen */
  ${({ $isOpen }) =>
    $isOpen
      ? css`
          display: none; /* Sakrij ako je otvoreno */
        `
      : css`
          display: flex; /* Prikaži ako nije otvoreno */
          align-items: center;
          justify-content: center;
          background-color: var(--bg-100);
        `}
`;

const Box = styled.div`
  width: 100%;
  ${({ $isOpen }) =>
    $isOpen
      ? css`
          animation: ${fadeOutBottom} 0.2s ease-in-out both;
        `
      : css`
          animation: ${fadeInTop} 0.3s ease-in-out both;
        `}
`;

const List = styled.div`
  padding: 2px 0;
  outline: none;
  list-style: none;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  box-shadow: var(--shadow-large);
  gap: 2px;
`;
const ListItem = styled(Link)`
  text-decoration: none;
  color: var(--text-200);

  padding: 14px 10px;
  background-color: var(--bg-200);

  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  &:hover svg {
    opacity: 1;
  }
`;

const SvgArrow = styled.svg`
  transition: transform 0.3s ease; /* Smooth transition */

  transform: rotate(-180deg);
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(-90deg);
    `}
`;
const FlagDiv = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const ButtonShell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const TButton = styled.button`
  margin-top: 14px;
  //padding: var(--spacing-sm) var(--spacing-lg);
  width: 90%;
`;
const LButton = styled(TButton)`
  background-color: var(--bg-200);
  border: none;
  color: var(--background-color);
`;
const FlexDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;
const Picture = styled.picture`
  background-color: ${({ color }) => color || "#fff"};

  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
const Image = styled.img`
  width: 24px;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
`;
const Logo = styled.div`
  color: var(--text-200);
  font-size: var(--font-size-xlarge);
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.438px;
  display: flex;
  gap: var(--spacing-xs);

  align-items: center;
  cursor: pointer;
  justify-content: center;
  margin-top: 14px;
`;
const HamburgerMenuData = ({ setIsOpen }) => {
  const { t, i18n } = useTranslation();
  const { brands } = useContext(ProductContext);
  const { setSelectedItem, authTokens } = useContext(AuthUserContext);
  const navigate = useNavigate();
  const {
    goToCategory,
    goToHome,
    goToShop,
    goToBestSeller,
    goToLogin,
    goToRegister,
    goToFeatured,
  } = useNavigation();

  const [isOpenBox, setIsOpenBox] = useState([true, true, true]);
  const [isOpenContainer, setIsOpenContainer] = useState([true, true, true]);
  const [isBoxAnimating, setIsBoxAnimating] = useState([false, false, false]);

  const toggleBox = (index) => {
    if (isBoxAnimating[index]) {
      return;
    }

    const updatedIsOpenBox = [...isOpenBox];
    updatedIsOpenBox[index] = !updatedIsOpenBox[index];
    setIsOpenBox(updatedIsOpenBox);

    const updatedIsBoxAnimating = [...isBoxAnimating];
    updatedIsBoxAnimating[index] = true;
    setIsBoxAnimating(updatedIsBoxAnimating);

    setTimeout(
      () => {
        const updatedIsOpenContainer = [...isOpenContainer];
        updatedIsOpenContainer[index] = !updatedIsOpenContainer[index];
        setIsOpenContainer(updatedIsOpenContainer);

        updatedIsBoxAnimating[index] = false;
        setIsBoxAnimating(updatedIsBoxAnimating);
      },
      !isOpenContainer[index] ? 200 : 10
    );
  };

  const toggleMenu = () => {
    setIsOpen(false);
  };

  const toggleCategory = (event, category) => {
    event.preventDefault();
    navigate(goToCategory(category.name));
    toggleMenu();
  };

  return (
    <Container>
      <Wrapper>
        <GridContainer>
          <GridItems>
            <ButtonWrapper>
              <Button
                onClick={() => {
                  navigate(goToShop());
                }}
              >
                {t("HEADER.LINKS.TOP_BRANDS")}
              </Button>
            </ButtonWrapper>
            <CategoryGrid>
              {brands.slice(0, 4).map((category, index) => (
                <CategoryGridItem
                  key={index}
                  onClick={(event) => toggleCategory(event, category)}
                >
                  {category.name}
                </CategoryGridItem>
              ))}
            </CategoryGrid>
          </GridItems>

          <GridItems>
            <ButtonWrapper>
              <Button
                onClick={() => {
                  navigate(goToShop());
                }}
              >
                {t("MENU.NICOTINE_POUCHES")}
              </Button>
            </ButtonWrapper>
          </GridItems>

          <GridItems>
            <ButtonWrapper>
              <Button onClick={() => toggleBox(1)}>
                {t("MENU.BRANDS")}
                <ButtonIcon role="presentation">
                  <SvgArrow
                    fill="var(--text-200)"
                    width="30px"
                    height="30px"
                    viewBox="0 0 1024 1024"
                    xmlns="http://www.w3.org/2000/svg"
                    $isOpen={isOpenBox[1]}
                  >
                    <path d="M759.2 419.8L697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z" />
                  </SvgArrow>
                </ButtonIcon>
              </Button>
            </ButtonWrapper>

            <DropDown $isOpen={isOpenContainer[1]}>
              <Box $isOpen={isOpenBox[1]}>
                {" "}
                {/* Prikažemo sadržaj sekcije */}
                <List>
                  {brands &&
                    brands.length > 0 &&
                    brands.map((category, index) => (
                      <ListItem
                        key={index}
                        onClick={(event) => {
                          toggleCategory(event, category);
                        }}
                      >
                        <FlexDiv>{category.name}</FlexDiv>
                      </ListItem>
                    ))}
                </List>
              </Box>
            </DropDown>
          </GridItems>
          <GridItems>
            <ButtonWrapper>
              <Button onClick={() => navigate(`/${i18n.language}/best-seller`)}>
                {t("HEADER.LINKS.TOP_BRANDS")}
              </Button>
            </ButtonWrapper>
          </GridItems>
          <GridItems>
            <ButtonWrapper>
              <Button
                onClick={() => navigate(`/${i18n.language}/new-arrivals`)}
              >
                {t("HEADER.LINKS.NEW_ARRIVALS")}
              </Button>
            </ButtonWrapper>
          </GridItems>
          <GridItems>
            <ButtonWrapper>
              <Button onClick={() => navigate(goToBestSeller())}>
                {t("HEADER.LINKS.BLOG")}
              </Button>
            </ButtonWrapper>
          </GridItems>

          {!authTokens && (
            <ButtonShell>
              <LButton
                onClick={() => {
                  navigate(goToRegister());
                }}
              >
                {t("MENU.SIGN_UP")}
              </LButton>
              <TButton onClick={() => navigate(goToLogin())}>
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_414_6527)">
                    <path
                      d="M10.7135 2.104C11.5376 2.104 12.3432 2.34837 13.0284 2.80621C13.7136 3.26405 14.2477 3.9148 14.563 4.67616C14.8784 5.43752 14.9609 6.27529 14.8001 7.08355C14.6394 7.8918 14.2425 8.63423 13.6598 9.21695C13.0771 9.79967 12.3347 10.1965 11.5264 10.3573C10.7182 10.518 9.88039 10.4355 9.11903 10.1202C8.35767 9.8048 7.70692 9.27075 7.24908 8.58555C6.79125 7.90034 6.54688 7.09476 6.54688 6.27067L6.55104 6.08984C6.59764 5.01713 7.05655 4.00382 7.83206 3.26122C8.60757 2.51862 9.63982 2.10407 10.7135 2.104Z"
                      fill="white"
                    />
                    <path
                      d="M12.3789 12.104C13.484 12.104 14.5438 12.543 15.3252 13.3244C16.1066 14.1058 16.5456 15.1656 16.5456 16.2707V17.104C16.5456 17.546 16.37 17.97 16.0574 18.2825C15.7449 18.5951 15.3209 18.7707 14.8789 18.7707H6.54557C6.10355 18.7707 5.67962 18.5951 5.36706 18.2825C5.0545 17.97 4.87891 17.546 4.87891 17.104V16.2707C4.87891 15.1656 5.31789 14.1058 6.09929 13.3244C6.8807 12.543 7.9405 12.104 9.04557 12.104H12.3789Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_414_6527">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.712891 0.4375)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                {t("MENU.LOGIN")}
              </TButton>
            </ButtonShell>
          )}
          <Logo onClick={() => navigate(goToHome())}>
            <svg
              width="50"
              height="50"
              viewBox="0 0 298 298"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M148.707 0C66.7245 0 0 66.7245 0 148.707C0 230.689 66.7245 297.414 148.707 297.414C230.689 297.414 297.414 230.689 297.414 148.707C297.414 66.7245 230.689 0 148.707 0ZM294.707 148.707C294.707 188.275 278.843 224.204 253.18 250.567L244.688 242.074C268.158 217.904 282.669 184.962 282.669 148.707C282.669 112.452 267.878 78.8562 243.988 54.6394L252.48 46.1472C278.563 72.557 294.661 108.766 294.661 148.707H294.707ZM17.3576 148.707C17.3576 76.2899 76.2432 17.4043 148.66 17.4043C221.077 17.4043 279.963 76.2899 279.963 148.707C279.963 221.124 221.077 280.009 148.66 280.009C76.2432 280.009 17.3576 221.124 17.3576 148.707ZM250.52 44.2808L242.028 52.7731C217.858 29.2562 184.915 14.7447 148.614 14.7447C112.312 14.7447 79.416 29.2562 55.2458 52.7731L46.7536 44.2808C73.0701 18.6176 108.999 2.75295 148.567 2.75295C188.135 2.75295 224.11 18.6175 250.427 44.3275L250.52 44.2808ZM44.7939 46.1939L53.2862 54.6862C29.3494 78.9029 14.558 112.172 14.558 148.8C14.558 185.429 29.0693 218.044 52.5862 242.214L44.1406 250.707C18.4307 224.39 2.56627 188.415 2.56627 148.847C2.56627 109.279 18.7107 72.6504 44.7939 46.2872V46.1939ZM46.0539 252.667L54.5461 244.174C78.7629 268.064 111.985 282.856 148.614 282.856C185.242 282.856 218.511 268.064 242.728 244.128L251.22 252.62C224.857 278.703 188.602 294.848 148.66 294.848C108.719 294.848 72.5102 278.703 46.147 252.667"
                fill="var(--text-200)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M207.722 57.7351C202.622 66.9627 200.922 78.8759 205.416 87.3302C214.54 104.491 230.158 114.314 239.894 131.851C273.15 191.781 209.011 201.72 174.784 209.915C155.428 214.537 143.812 230.506 158.492 258.688C214.436 253.98 258.39 207.07 258.39 149.903C258.39 111.144 238.177 77.1018 207.722 57.7266"
                fill={"var(--text-200)"}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M191.927 105.506C177.373 95.2564 162.525 82.7355 160.972 63.8935C160.307 55.8558 164.875 48.4915 171.632 43.0459C157.459 40.0907 142.84 39.9776 128.623 42.713C114.406 45.4483 100.873 50.9779 88.8086 58.9812C96.9207 91.2874 127.561 94.6763 155.629 103.143C195.722 115.235 214.322 153.656 158.871 159.818C81.4401 168.423 72.2954 187.545 127.861 256.987C133.447 258.095 139.112 258.763 144.803 258.984C114.222 212.039 131.18 198.9 188.95 180.965C245.166 163.485 224.646 128.565 191.925 105.51"
                fill="var(--text-100)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M123.936 118.509C100.162 114.213 67.312 112.348 58.2119 97.5595C57.3549 96.166 56.5939 94.7157 55.9342 93.2188C45.5264 110.296 40.0342 129.915 40.0626 149.915C40.0626 197.952 71.1131 238.761 114.236 253.341C95.0693 233.567 63.4812 210.21 71.1047 172.043C76.204 146.547 105.038 150.269 127.675 148.404C160.298 145.722 156.82 124.463 123.927 118.509"
                fill={"var(--text-200)"}
              />
            </svg>
            SnusCo
          </Logo>
        </GridContainer>
      </Wrapper>
    </Container>
  );
};

export default HamburgerMenuData;
